
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import Cookies from 'js-cookie'
import { getEmployeeProfile, updateEmployeeProfile } from '@/api/employee'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'Profile'
})
export default class extends Vue {
  @Prop({ default: false }) private dialogVisible!: boolean

  private visible = false
  private saving = false
  private username = ''
  private form = {
    name: '',
    phone: '',
    email: ''
  }
  private rules = {
    name: [
      { required: true, message: '请输入姓名', trigger: 'blur' },
      { max: 32, message: '姓名不能超过32个字符', trigger: 'blur' }
    ],
    phone: [
      {
        required: true,
        validator: (_rule: any, value: string, callback: Function) => {
          const v = (value || '').trim()
          if (!v) {
            callback(new Error('请输入手机号'))
            return
          }
          if (!/^1[3-9]\d{9}$/.test(v)) {
            callback(new Error('请输入正确的手机号'))
            return
          }
          callback()
        },
        trigger: 'blur'
      }
    ],
    email: [
      {
        validator: (_rule: any, value: string, callback: Function) => {
          const v = (value || '').trim()
          if (!v) {
            callback()
            return
          }
          if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v)) {
            callback(new Error('邮箱格式不正确'))
            return
          }
          callback()
        },
        trigger: 'blur'
      }
    ]
  }

  @Watch('dialogVisible', { immediate: true })
  private onDialogVisible(val: boolean) {
    this.visible = !!val
  }

  private async onOpen() {
    this.saving = false
    try {
      const res: any = await getEmployeeProfile()
      const body = res && res.data
      if (body && String(body.code) === '1' && body.data) {
        const d = body.data
        this.username = d.username || ''
        this.form.name = d.name || ''
        this.form.phone = d.phone || ''
        this.form.email = d.email || ''
        return
      }
    } catch (_) {
      /* fallback below */
    }
    const info = (UserModule.userInfo as any) || {}
    this.username = info.userName || info.username || Cookies.get('username') || ''
    this.form.name = info.name || ''
    this.form.phone = info.phone || ''
    this.form.email = info.email || ''
  }

  private handleSave() {
    if (this.saving) return
    ;(this.$refs.form as ElForm).validate(async (valid: boolean) => {
      if (!valid) return
      this.saving = true
      try {
        const res: any = await updateEmployeeProfile({
          name: String(this.form.name || '').trim(),
          phone: String(this.form.phone || '').trim(),
          email: String(this.form.email || '').trim()
        })
        const body = res && res.data
        if (!body || String(body.code) !== '1') {
          this.$message.error((body && (body.msg || body.desc)) || '保存失败')
          return
        }
        const updated = body.data || {}
        await UserModule.UpdateProfileInfo({
          name: updated.name != null ? updated.name : String(this.form.name || '').trim(),
          phone: updated.phone != null ? updated.phone : String(this.form.phone || '').trim(),
          email: updated.email != null ? updated.email : String(this.form.email || '').trim()
        })
        this.$message.success('保存成功')
        this.$emit('handleclose')
      } catch (_) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    })
  }

  private handleClose() {
    if (this.$refs.form) {
      ;(this.$refs.form as ElForm).clearValidate()
    }
    this.$emit('handleclose')
  }
}
